import { Attachment } from "@wizeoo/akm-message-lib";

/**
 * Classe utilitaire sur les attachments
 */
export class AttachmentUtils {
  /**
   * Fonction de vérification de la modification d'un attachment
   */
  public static hasChanged(previousAttachment: Attachment, attachment: Attachment): boolean {
    if ((!previousAttachment && attachment) || (previousAttachment && !attachment)) {
      return true;
    }
    return (
      attachment?.fileContent !== previousAttachment?.fileContent ||
      attachment?.fileName !== previousAttachment?.fileName
    );
  }

  /**
   * Checke la validité d'un attachment.
   */
  public static isValid(attachment: Attachment): boolean {
    return !!attachment?.fileContent && !!attachment.fileName && !!attachment.fileType;
  }
}
